'use client';
import { useRouter } from 'next/navigation';

type Props = {};

export const BackButton: React.FC<Props> = () => {
  const router = useRouter();

  return (
    <button
      onClick={() => router.back()}
      type="button"
      className="group cursor-pointer">
      go back
      <span className="bg-primary-500 z-0 -mt-0.5 block h-0.5 w-full transition-all duration-500 ease-out group-hover:w-1/3" />
    </button>
  );
};
